import { render, staticRenderFns } from "./KpiSelectCategory.vue?vue&type=template&id=347580e2"
import script from "./KpiSelectCategory.vue?vue&type=script&lang=ts"
export * from "./KpiSelectCategory.vue?vue&type=script&lang=ts"
import style0 from "./KpiSelectCategory.vue?vue&type=style&index=0&id=347580e2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports